import React from 'react'
import { Box } from '@mui/material'
import { Topbar } from 'layouts'
import EscalationsTable from './escalations/escalations-table'

const EscalationsPage: React.FC = () => {
  return (
    <>
      <Topbar title="Escalations" />
      <Box sx={{ p: 3 }}>
        <EscalationsTable />
      </Box>
    </>
  )
}

export { EscalationsPage }
export default EscalationsPage
